import { render, staticRenderFns } from "./assist-lawsuit-confirm-distribution.vue?vue&type=template&id=093b49b2&scoped=true"
import script from "./assist-lawsuit-confirm-distribution.vue?vue&type=script&lang=ts"
export * from "./assist-lawsuit-confirm-distribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b49b2",
  null
  
)

export default component.exports